import { Button } from '@/components/ui/button'
import { useAssinarDocumentoMutation } from '@/hooks/useAssinaturas'
import { toast } from '@/hooks/use-toast'
import { FileSignature, Loader2 } from 'lucide-react'

interface AssinarDocumentoButtonProps {
  prontuarioId: number
  protocoloId: number
  tipoProtocolo: string
  onSuccess?: () => void
  size?: 'default' | 'sm' | 'lg' | 'icon'
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link'
}

export function AssinarDocumentoButton({
  prontuarioId,
  protocoloId,
  tipoProtocolo,
  onSuccess,
  size = 'sm',
  variant = 'outline'
}: AssinarDocumentoButtonProps) {
  const assinarMutation = useAssinarDocumentoMutation()

  const handleAssinar = async () => {
    try {
      await assinarMutation.mutateAsync({
        prontuarioId,
        protocoloId,
        tipoProtocolo
      })
      toast({
        title: 'Documento assinado',
        description: 'O documento foi assinado digitalmente com sucesso.'
      })
      onSuccess?.()
    } catch (err: any) {
      const msg =
        err?.message ||
        err?.response?.data?.message ||
        'Não foi possível assinar. Verifique se seu certificado A1 está configurado.'
      toast({
        title: 'Erro ao assinar',
        description: msg,
        variant: 'destructive'
      })
    }
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleAssinar}
      disabled={assinarMutation.isPending}
    >
      {assinarMutation.isPending ? (
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
      ) : (
        <FileSignature className="h-4 w-4 mr-2" />
      )}
      Assinar documento
    </Button>
  )
}
